import { useMutation, useQueryClient } from '@tanstack/vue-query';

import { revokeUserSupportAccessToAccount } from '../api/me';
import { keys } from '../keys';

export const useRevokeUserSupportAccessToAccount = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: revokeUserSupportAccessToAccount,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: keys.accounts.supportGranted._def });
    },
  });
};
